module.exports = __webpack_public_path__ + "img/data_tool.d3915d72.svg";